import React, { useEffect, useState } from "react";

import { Box, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import makeStyles from "hooks/makeStyles";
import useCart from "hooks/useCart";
import useDeliveryOrPickupAtController from "hooks/useDeliveryOrPickupAtController";
import Clock from "icons/ClockNine";

import OrderTimeSelectorRendererMobile from "./OrderTimeSelectorRenderer.Mobile";
import ReadyTimeMessage from "./ReadyTimeMessage";

const useStyles = makeStyles(theme => ({
	icon: {
		verticalAlign: "center",
		marginRight: 10,
		fill: "#fff",
		[theme.breakpoints.up(480)]: {
			fill: theme.palette.text.primary
		}
	},
	orderTypeDeliverySummary: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		// margin: `0 ${theme.spacing(2)}px`,

		"&__info": {
			display: "flex",
			alignItems: "center",
			fontWeight: 400
		},

		"&__change": {
			textTransform: "uppercase",
			marginLeft: "15px"
		}
	},
	orderTypeDeliverySummaryText: {
		fontSize: "12px"
	},
	availabilityWarning: {
		padding: `${theme.spacing(1)}px 0 0 ${theme.spacing(2)}px`,
		fontSize: "14px",
		color: theme.palette.warning.main
	}
}));

interface Props {
	isEditable: boolean;
}

const SelectPickUpDateTime = ({ isEditable }: Props) => {
	const setIntervalState = useState(false)[1];
	const [isChangeMode, setChangeMode] = useState(false);
	const { areAllItemsAvailable } = useCart();
	const rendererProps = useDeliveryOrPickupAtController({ visible: isEditable && isChangeMode });
	const { t } = useTranslation();
	const classes = useStyles();

	// re-render every 30 seconds
	useEffect(() => {
		const interval = setInterval(() => {
			setIntervalState(x => !x);
		}, 30000);

		return () => {
			clearInterval(interval);
		};
	}, [setIntervalState]);

	return (
		<>
			<Box className={classes.orderTypeDeliverySummary}>
				{!isEditable ? null : (
					<>
						<Box className={`${classes.orderTypeDeliverySummary}__info`}>
							<Clock className={classes.icon} width="15" height="15" />
							<Typography className={classes.orderTypeDeliverySummaryText}>
								<ReadyTimeMessage />
							</Typography>
						</Box>
						<Box className={`${classes.orderTypeDeliverySummary}__change`}>
							<Typography
								className={classes.orderTypeDeliverySummaryText}
								onClick={e => {
									e.preventDefault();
									setChangeMode(true);
								}}
							>
								{/* {isEditable && t("change")} */}
							</Typography>
						</Box>
					</>
				)}
			</Box>
			{areAllItemsAvailable() ? null : (
				<Typography className={classes.availabilityWarning}>
					Some items in your cart are unavailable at the selected time
				</Typography>
			)}
			{!isEditable ? null : <OrderTimeSelectorRendererMobile {...rendererProps} />}
		</>
	);
};

export default SelectPickUpDateTime;
